// extracted by mini-css-extract-plugin
export default {"description":"SanitizedServiceDescription_description__GAZ+0"};